// extracted by mini-css-extract-plugin
module.exports = {"container":"FeedbackFormSmallV2_container__Qifja","actionsContainer":"FeedbackFormSmallV2_actionsContainer__3Rcfy","formSentMessage":"FeedbackFormSmallV2_formSentMessage__1y219"};